module.exports = __webpack_public_path__ + "img/dairy_milk_only-min.e242f97a.png";